import React from "react";
import Avatar from "@material-ui/core/Avatar";

const tabConfig = [
  {
    columnTitle: "",
    dataField: ["position"],
  },
  {
    columnTitle: "",
    dataField: ["component"],
    component: ({ values }) => {
      return <Avatar src={values.coverImageURL} variant="rounded" />;
    },
  },
  {
    columnTitle: "Title",
    dataField: ["title"],
  },
  {
    columnTitle: "Description",
    dataField: ["shortDescription"],
  },
  {
    columnTitle: "Category",
    dataField: ["categoryName"],
  },
];

export const stepTabConfig = [
  {
    columnTitle: "Position",
    dataField: ["position"],
  },
  {
    columnTitle: "Title",
    dataField: ["title"],
  },
  {
    columnTitle: "Subtitle",
    dataField: ["subtitle"],
  },
  {
    columnTitle: "Description",
    dataField: ["description"],
  },
];

export const questionTabConfig = [
  {
    columnTitle: "Options",
    dataField: ["options.length"],
  },
  {
    columnTitle: "Question",
    dataField: ["question"],
  },
  {
    columnTitle: "Type",
    dataField: ["type"],
  },
];
export default tabConfig;
